import request from "@/utils/request";
export const getAllHotel = params => {
    return request.request({
        url: "/m/hotel/api/getList",
        params,
    });
};
export const getHotelDetail = params => {
    return request.request({
        url: "/m/hotel/api/getByDetail",
        params,
    });
};
export const getPolicy = params => {
    return request.request({
        url: "/m/rules/api/getOne",
        params,
    });
};
export const getRoomList = params => {
    return request.request({
        url: "/m/room/api/getList",
        params,
    });
};
export const getRoomDetail = params => {
    return request.request({
        url: "/m/room/api/getByDetail",
        params,
    });
};
export const orderBuy = data => {
    return request.request({
        url: "/m/order/buy",
        method: "POST",
        data,
    });
};

export const getOrderList = params => {
    return request.request({
        url: "/m/order",
        params,
    });
};
export const getOrderDetail = id => {
    return request.request({
        url: `/m/order/api/${id}`,
    });
};
export const test = () => {
    return request.request({
        baseURL: "http://192.168.1.176:8080",
        url: `/common/test4`,
    });
};
export const applyService = data => {
    return request.request({
        url: `/m/custService/applyService`,
        method: "POST",
        data,
    });
};
export const getCusServiceObj = params => {
    return request.request({
        url: "/m/custService/getOne",
        method: "get",
        params,
    });
};
